export default __webpack_public_path__ + "static/media/nyrasysis-500.bd59ba5d.webp";